<template>
	<div id="app">
		<!-- <TheNav /> -->
		<router-view />
		<transition
			name="fade"
		>
			<div v-if="isLoading" id="loading">
				<span>
					<font-awesome-icon class="fa-spin" icon="circle-notch" />
					読込中
				</span>
			</div>
		</transition>
	</div>
</template>

<script>
import Mixins from '@/mixins'
export default {
	name: 'App',
	mixins: [Mixins.navigator],
	components: {
	},
	watch: {
		'$route' (to, from, next) {
			if (this.navigator.mobile === null) {
				return this.$router.push({ name: 'appNotes' })
					.catch(() => {
					})
			}
		}
	},
	mounted () {
	},
	computed: {
		isLoading () {
			return this.$store.getters['Utility/getIsLoading']
		}
	},
	created () {
		this.$_navigatorMixin_detect()
	}
}
</script>

<style lang="stylus" scoped>
#app
	-webkit-font-smoothing antialiased
	-moz-osx-font-smoothing grayscale
</style>

<style lang="stylus">
@import "~@/themes/styles/common.styl"

html
body
	margin 0
	background-color white
	color black
	#loading
		position fixed
		top 0
		left 0
		width 100%
		height 100%
		background rgba(0,0,0,0.7)
		display flex
		justify-content center
		flex-direction column
		align-items center
		color #fff
		z-index 999
	.ws100
		width 100%
</style>
